<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

const props = defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const MODES = [
  { value: 'grid', label: t('site.f.gallery.opt_grid', 'Grid') },
  { value: 'carousel', label: t('site.f.gallery.opt_carousel', 'Carousel') }
] as const

const COLUMNS = [
  { value: 2, label: t('site.f.gallery.opt_2', '2') },
  { value: 3, label: t('site.f.gallery.opt_3', '3') },
  { value: 4, label: t('site.f.gallery.opt_4', '4') }
] as const

const addImage = () => {
  props.block.data.images = [...(props.block.data.images ?? []), { url: '', alt: '' }]
}
const removeImage = (i: number) => {
  props.block.data.images?.splice(i, 1)
}
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.common.heading_optional', 'Heading (optional)')">
    <UInput
      v-model="block.data.headline"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.common.layout_label', 'Layout')">
    <SiteEditorOptionToggle
      :options="MODES"
      :model-value="block.data.mode ?? 'grid'"
      @update:model-value="block.data.mode = $event as 'grid' | 'carousel'"
    />
  </UFormField>
  <UFormField
    v-if="block.data.mode !== 'carousel'"
    :label="t('site.f.common.columns_label', 'Columns')"
  >
    <SiteEditorOptionToggle
      :options="COLUMNS"
      :model-value="block.data.columns ?? 3"
      @update:model-value="block.data.columns = Number($event)"
    />
  </UFormField>

  <SiteEditorArrayItemCard
    v-for="(img, i) in block.data.images ?? []"
    :key="i"
    :label="`${t('site.f.gallery.item_label', 'Image')} ${i + 1}`"
    @remove="removeImage(i)"
  >
    <SiteEditorImagePicker
      variant="field"
      :model-value="img.url"
      @update:model-value="img.url = $event"
    />
    <UInput
      :model-value="img.alt ?? ''"
      :placeholder="t('site.f.gallery.alt_text', 'Alt text (for screen readers)')"
      class="w-full"
      @update:model-value="img.alt = String($event)"
    />
    <UInput
      :model-value="img.caption ?? ''"
      :placeholder="t('site.f.common.caption_label', 'Caption')"
      class="w-full"
      @update:model-value="img.caption = String($event)"
    />
    <UInput
      :model-value="img.link_url ?? ''"
      :placeholder="t('site.f.common.link_url_optional_label', 'Link URL (optional)')"
      class="w-full"
      @update:model-value="img.link_url = String($event)"
    />
  </SiteEditorArrayItemCard>

  <UButton
    size="sm"
    variant="outline"
    color="neutral"
    icon="i-lucide-plus"
    @click="addImage"
  >
    {{ t('site.f.gallery.add_item', 'Add image') }}
  </UButton>
</template>
